import { render, staticRenderFns } from "./MetricInfoCard.vue?vue&type=template&id=4553f730&scoped=true"
import script from "./MetricInfoCard.vue?vue&type=script&lang=ts"
export * from "./MetricInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553f730",
  null
  
)

export default component.exports